import * as types from "../constants/ActionTypes";


export const initialState = {
    type: "init",
    payment: "paypal",
    status: "all"
}

const filterIndicator = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_FILTER:
            state.type = action.filter.type;
            state.payment = action.filter.payment;
            state.status = action.filter.status;
            return { ...state };
        default:
            return { ...state };

    }
}

export default filterIndicator;